import { createSelector } from 'reselect';
import moment from 'moment';
import { StoreState } from '../../store-interfaces';
import { Contact, OrderedContact } from '../../interfaces/contacts';

const getContacts = (state: StoreState) => state.contacts.contacts;

export const getFormattedContacts = (contacts: Contact[]): OrderedContact[] =>
  contacts.map(contact => {
    const { createdAt, timezone, firstName, lastName } = contact;
    const formattedCreatedAt = moment(createdAt).format('MM/DD/YYYY');

    let formattedTimezone: string;

    if (Number(timezone) === 0) formattedTimezone = '';

    if (Number(timezone) > 0) {
      formattedTimezone = `+${timezone}`;
    } else {
      formattedTimezone = timezone;
    }

    return {
      ...contact,
      formattedCreatedAt,
      formattedTimezone: timezone ? `GMT ${formattedTimezone}` : undefined,
      fullName: `${firstName} ${lastName}`,
    } as OrderedContact;
  });

export const formattedContactsSelector = createSelector(
  [getContacts],
  getFormattedContacts,
);
